"use client";

import { logger } from "@/utils/logger";
import { trackEvent } from "./track-event";

interface RequestVisitTrackingProps {
	unitId?: string;
	projectId?: string;
	conversionLabel?: string;
	event?: string;
	category?: string;
	additionalOptions?: Record<string, unknown>;
}

/**
 * Track request visit events with Google Ads conversion
 * Based on events from i/webapp/client/gtag/requestVisit.js
 */
export function trackRequestVisit({
	unitId,
	projectId,
	conversionLabel = "7aHoCISOqsoDELfPrrMB",
	event = "request-visit",
	category,
	additionalOptions = {},
}: RequestVisitTrackingProps = {}) {
	try {
		// Google Ads conversion tracking
		trackEvent({
			google: {
				event: event,
				options: {
					send_to: `AW-881882540/${conversionLabel}`,
					unit_id: unitId,
					project_id: projectId,
					event_category: category,
					...additionalOptions,
				},
			},
		});

		// For everything else, track a Matomo event/google event
		trackEvent({
			matomo: {
				event: "request visit on " + ((additionalOptions?.event_label as string) || ""),
				options: {
					category: (additionalOptions?.event_label as string) || "visit_request",
				},
			},
			google: { event: "request_visit" },
		});

		// Facebook InitiateCheckout event
		trackEvent({
			facebook: {
				event: "InitiateCheckout",
				options: {
					content_name: "Property Visit Request",
					content_category: "real_estate",
					value: 1,
					currency: "INR",
					unit_id: unitId,
					project_id: projectId,
				},
			},
		});
	} catch (error) {
		// Catch any error to avoid breaking the main flow

		logger.debug("Error tracking request visit :", error);
	}
}

/**
 * Track request visit for specific unit
 */
export function trackRequestVisitForUnit(unitId: string, additionalOptions?: Record<string, unknown>) {
	trackRequestVisit({
		unitId,
		additionalOptions: {
			...additionalOptions,
			event_label: "unit_visit_request",
		},
	});
}

/**
 * Track request visit for project
 */
export function trackRequestVisitForProject(projectId: string, additionalOptions?: Record<string, unknown>) {
	trackRequestVisit({
		projectId,
		additionalOptions: {
			...additionalOptions,
			event_label: "project_visit_request",
		},
	});
}
